import tourismTaxReportApi from "../../api/report/tourismTaxReportApi";

export interface TourismTaxReportFilter {
    branchId?: number;
    dateFrom: string; // yyyy-MM-dd
    dateTo: string; // yyyy-MM-dd
}

const TourismTaxReportService = {

    /** POST /api/reports/tourism-tax/search */
    search: async (filter: TourismTaxReportFilter) => {
        const response = await tourismTaxReportApi.addCustom("/search", filter);
        return response.data;
    },

    /** POST /api/reports/tourism-tax/export/pdf */
    exportPdf: async (filter: TourismTaxReportFilter) => {
        return await tourismTaxReportApi.downloadFileFromBlob(
            "/export/pdf", filter, "turismo_alojamiento.pdf");
    },

    /** POST /api/reports/tourism-tax/export/excel */
    exportExcel: async (filter: TourismTaxReportFilter) => {
        return await tourismTaxReportApi.downloadFileFromBlob(
            "/export/excel", filter, "turismo_alojamiento.xlsx");
    },

};

export default TourismTaxReportService;
